import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-forget-password',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './forget-password.component.html',
  styleUrl: './forget-password.component.scss',
})
export class ForgetPasswordComponent implements OnInit {
  forgotPasswordForm!: FormGroup;
  errMsg: String = '';
  isSubmitted: boolean = false;
  constructor(private _router: Router) {}

  ngOnInit(): void {
    //Forget username form initialization
    this.forgotPasswordForm = new FormGroup({
      userName: new FormControl('', [Validators.required]),
    });
  }
  // convenience getter for easy access to form fields
  get form() {
    return this.forgotPasswordForm.controls;
  }

  // Navigate to sign-in page
  backToSignin() {
    this._router.navigate(['/login']);
  }
  // Submit the form
  onSubmit() {
    this.isSubmitted = true;
    if (!this.forgotPasswordForm.valid) {
      this._router.navigate(['/user-profile/call-us']);
    } else {
      // submit the form
    }
  }
}
